module.exports = __webpack_public_path__ + "assets/img/product-country3-2.3f4a98d4.png";